import { Component, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { FooterComponent } from '../footer/footer.component';
import { HeaderComponent } from '../header/header.component';
import { MatCardModule } from '@angular/material/card';
import { MatTableModule } from '@angular/material/table';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { SicotService } from '../sicot.service';
import { Comune } from '../types/Comune';

@Component({
    selector: 'app-admin-comuni',
    imports: [
        RouterLink,
        HeaderComponent,
        FooterComponent,
        MatCardModule,
        MatTableModule,
        MatProgressSpinnerModule,
        MatFormFieldModule,
        MatInputModule,
        MatPaginatorModule
    ],
    templateUrl: './admin-comuni.component.html',
    styleUrl: './admin-comuni.component.css'
})
export class AdminComuniComponent implements OnInit {

    comuni: Comune[] = [];
    caricamento = true;
    errore: string | null = null;
    displayedColumns: string[] = ['istatCode', 'nome', 'provinciaSigla', 'regioneNome', 'validFrom', 'validTo'];

    totalElements = 0;
    pageIndex = 0;
    pageSize = 10;
    pageSizeOptions = [5, 10, 20, 50];

    searchText = '';
    private searchTimeout: ReturnType<typeof setTimeout> | null = null;

    get totalPages(): number {
        return this.pageSize > 0 ? Math.ceil(this.totalElements / this.pageSize) : 1;
    }

    constructor(private sicotService: SicotService) {}

    ngOnInit(): void {
        this.loadPage();
    }

    loadPage(): void {
        this.caricamento = true;
        this.errore = null;
        this.sicotService.getComuniPage(
            this.pageIndex,
            this.pageSize,
            this.searchText || undefined,
            'nome,asc'
        ).subscribe({
            next: (page) => {
                this.comuni = page.content;
                this.totalElements = page.totalElements;
                this.caricamento = false;
            },
            error: () => {
                this.errore = 'Errore nel caricamento dei comuni.';
                this.caricamento = false;
            }
        });
    }

    onPage(event: PageEvent): void {
        this.pageIndex = event.pageIndex;
        this.pageSize = event.pageSize;
        this.loadPage();
    }

    onSearchInput(event: Event): void {
        this.searchText = (event.target as HTMLInputElement).value?.trim() ?? '';
        if (this.searchTimeout != null) {
            clearTimeout(this.searchTimeout);
        }
        this.searchTimeout = setTimeout(() => {
            this.searchTimeout = null;
            this.pageIndex = 0;
            this.loadPage();
        }, 300);
    }
}
